import React, { useState, useEffect, useContext } from 'react'
import { useNavigate, Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { server ,Origin} from '../server';
import axios from 'axios';
import { Company_Id } from '../Helper'
import { Corporate_Id } from '../Helper'
import { Corporate_Name } from '../Helper'
import { Vendor_Id } from '../Helper'
import { Vendor_Name } from '../Helper'


function Login() {
// console.log('Version-'+axios.VERSION);
  //local details-----------------
  //  const Corporate_ID = 13611;
  //  const Corporate_Name = 'O3MPLRetail';
  //  const Vendor_Id = 2584;
  //  const Vendor_Name = 'O3MPL';
  // local details -----------------

  localStorage.setItem('isLogin', false);
  localStorage.removeItem('isLogin');
  localStorage.removeItem('EmployeeName');
  localStorage.removeItem('userid');
  localStorage.removeItem('userName');
  localStorage.removeItem('emailId');
  localStorage.removeItem('contactNo');

const [isLoading, setIsLoading] = useState(false);


  // CompanyId: "13996",
  // CorporateId: "13647",
  // CorporateName: "O3MPLRetail",
  // VendorId: "2587",
  // VendorName:"O3MPL",
  //========== Local======================
  // CorporateId: "13611", 
  // CorporateName: "O3MPLRetail",
  // VendorId:"2584",
  // VendorName:"O3MPL"


  // const initialValues = {
  //   MobileNo: "", UserPass: "",
  //   CorporateId: _corporateId,
  //   CorporateName: _corporatename,
  //   VendorId: _vendorId,
  //   VendorName: _vendorName

  // }

  const [formvalue, setFormValue] = useState(
    {
      UserName: "", UserPass: "",
      CompanyId: "",
      CorporateId: "",
      CorporateName: "",
      VendorId: "",
      VendorName: "RGML",
    }

  );
  const [formErrors, setFormErrors] = useState({});
  const [IsSubmit, setIsSubmit] = useState(false);

  //debugger;
  const handChange = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formvalue, [name]: value });
    //console.log(formvalue);
  }
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormErrors(validate(formvalue));
    setIsSubmit(true);

    
  }
  useEffect(() => {

    if (Object.keys(formErrors).length == 0 && IsSubmit) {
      // console.log(formvalue);
      userLogin(formvalue);
    }
  }, [formErrors]);
  function validateMobileNo(UserName) {
    const mobileNoPattern = /^[0-9]{10}$/; // Adjust the pattern as needed
    return mobileNoPattern.test(UserName);
  }
  const validate = (value) => {
    const errors = {};
    if (!value.UserName) {
      errors.UserName = "UserName is required";
    }
    // if(!validateMobileNo(value.MobileNo)){
    //   errors.MobileNo = "Mobile No is not valid";
    // }
    // if(!(value.UserName)){
    //   errors.UserName = "Mobile No is not valid";
    // }

    if (!value.UserPass) {
      errors.UserPass = "Password is required";
    }
    return errors;
  };
async function userLogin(formvalue) {
  setIsLoading(true); // 🔄 Start loading

  try {
    let result = await fetch(`${server}/api/Siemens/Login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "text/plain"
      },
      body: JSON.stringify(formvalue)
    });

    result = await result.json();
    console.log(result);

    if (result.statusCode == 200 && result.statusMessage === 'Login Successfully') {
      localStorage.setItem('isLogin', true);
      localStorage.setItem('EmployeeName', result.data[0].EmployeeName);
      localStorage.setItem('userid', result.data[0].EmpID);
      localStorage.setItem('userName', result.data[0].UserName);
      localStorage.setItem('emailId', result.data[0].EmailId);
      localStorage.setItem('contactNo', result.data[0].MobileNo);
      localStorage.setItem('Token', result.token);
      localStorage.setItem('WebUserPassword', result.data[0].Password);

      localStorage.setItem('Company_Id', result.data[0].Company_Id);
      localStorage.setItem('Corporate_Id', result.data[0].Corporate_Id);
      localStorage.setItem('Corporate_Name', result.data[0].Corporate_Name);
      localStorage.setItem('Vendor_Id', result.data[0].Vendor_Id);
      localStorage.setItem('Vendor_Name', result.data[0].Vendor_Name);
      localStorage.setItem('IsHideAirport', result.data[0].IsHideAirport);

      // export const Company_Id = 11434;
      // export const Corporate_Id = 11337;
      // export const Corporate_Name = 'Siemens';
      // export const Vendor_Id = 2583;
      // export const Vendor_Name = 'Refex';

      navigate('/Booking');
    } else if (result.statusCode == 100 && result.statusMessage === 'Invalid Login Credentials') {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Invalid Login !!',
      });
    }
  } catch (error) {
    console.error('Login error:', error);
    Swal.fire({
      icon: 'error',
      title: 'Login Failed',
      text: 'Something went wrong. Please try again.',
    });
  } finally {
    setIsLoading(false); // ✅ Stop loading
  }
}

  // async function userLogin(formvalue) {
  //   // debugger;
  //   // console.log('formvalue-' + formvalue);
  //   let result = await fetch(`${server}/api/Siemens/Login`, {
  //     method: "POST",
  //     headers: {
  //       // 'Origin': 'http://localhost:3000',
  //       "Content-Type": "application/json",
  //       "Accept": "text/plain"
  //     },
  //     body: JSON.stringify(formvalue)
  //   });
  //   result = await result.json();
  //   // console.log(result);

  //   // console.log('result-' + JSON.stringify(result));
  //   // console.log('result.statusCode-' + result.data[0].EmpID);

  //   if ((result.statusCode == 200) && (result.statusMessage === 'Login Successfully')) {
  //     localStorage.setItem('isLogin', true);
  //     localStorage.setItem('EmployeeName',result.data[0].EmployeeName);
  //     //localStorage.setItem('userid', formvalue.MobileNo);
  //     localStorage.setItem('userid', result.data[0].EmpID);
  //     localStorage.setItem('userName', result.data[0].UserName);
  //     localStorage.setItem('emailId', result.data[0].EmailId);
  //     localStorage.setItem('contactNo', result.data[0].MobileNo);
  //     localStorage.setItem('Token', result.token);
  //     localStorage.setItem('WebUserPassword', result.data[0].Password);
  //     //navigate('/Dashboard'); 

  //     // let logingDetails = {
  //     //   userId: result.userId,
  //     //   userName: result.userName,
  //     //   emailId: result.emailId,
  //     //   contactNo: result.contactNo
  //     // }

  //     //  debugger;

  //     // { state: { formvalue } }
  //     //navigate('/Booking', { state: { logingDetails } });
  //     navigate('/Booking');
  //   }
  //   if ((result.statusCode == 100) && (result.statusMessage === 'Invalid Login Credentials')) {
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Oops...',
  //       text: 'Invalid Login !!',

  //     })
  //   }
  // }

  return (

    <div className='hold-transition login-page'>
      <div className="login-box">
        <div className="card card-outline card-warning">
          <div className="card-header text-center">
            <img src="https://invoice.eveelz.in/invoice?q=driverapp/1747225392109_eveelz_logo_latest.png" alt="logo" style={{ width: '160px' }} />
          </div>
          <div className="card-body">

            <p className="login-box-msg">Sign in to start your session</p>
            <form onSubmit={handleSubmit}>

              <div className="input-group mb-3">
                <input name="UserName" type="text" className="form-control" placeholder="Email ID"
                  value={formvalue.UserName}
                  onChange={handChange}
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-mobile" />
                  </div>
                </div>
              </div>
              <p className='text-danger'>{formErrors.UserName}</p>
              <div className="input-group mb-3">
                <input name="UserPass" type="password" className="form-control" placeholder="Password"
                  value={formvalue.UserPass}
                  onChange={handChange}
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-lock" />
                  </div>
                </div>

              </div>
              <p className='text-danger'>{formErrors.UserPass}</p>
              <div className="row">
                {/* <div className="col-8">
                  <div className="icheck-primary">
                    <input type="checkbox" id="remember" />
                    <label htmlFor="remember">
                      Remember Me
                    </label>
                  </div>
                </div> */}

                
                <div className="col-12">
  <button 
    className="btn btn-warning btn-block" 
    // onClick={handleLoginClick} // make sure this calls userLogin
    disabled={isLoading}
  >
    {isLoading ? (
      <>
        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        Logging in...
      </>
    ) : (
      'Login'
    )}
  </button>
</div>

              </div>
            </form>
            <div className="social-auth-links text-center mt-2 mb-3">
            </div>

            <p className="mb-0">
              <Link to="/Registration" className="text-center text-danger">Register Now</Link>
              {/* <a href="register.html" className="text-center text-danger">Register now</a> */}
            </p>

          </div>
        </div>
      </div>
      {/* <div>
        <Link to="/RefundPolicy" target='_blank' className="text-center text-danger" style={{ fontSize: '12px', color: '#5b5b55 !important' }}>Privacy Policy</Link>
       
      </div> */}
    </div>
  )

}

export default Login;


